import React from 'react';

import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import { connect } from 'react-redux';

import MascoteSearchError from '../../assets/newsEditor/images/mascoteSearchError.svg';

import { extractContent } from '../../utils/utils';

import { UserActions } from '../../redux/actions';

class ModalDeleteNews extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      news: this.props.news,
      open: this.props.open,
    };
  }


  render() {
    const { news } = this.state;
    const newsTitle = extractContent(news.title);

    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.props.hdlClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            '*': {
              boxSizing: 'content-box !important',
            },
            '::after, ::before': {
              boxSizing: 'content-box !important',
            },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-25%, -50%)',
              width: 450,
              bgcolor: 'background.paper',
              borderRadius: '6px',
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography
              id="modal-modal-title"
              component={'span'}
              variant={'body2'}
            >
              <Grid container>
                <Grid className="attributeContainer" item xs={12}>
                  <div
                    className="img-banner"
                    style={{ display: 'flex', justifyContent: 'center' }}
                  >
                    <img
                      style={{ width: '120px', height: '120px' }}
                      src={MascoteSearchError}
                      alt="Logo"
                    />
                  </div>
                  <p
                    style={{
                      textAlign: 'center',
                      fontFamily: 'Roboto',
                      fontSize: '15px',
                    }}
                  >
                    Têm a certeza de que pretende eliminar a notícia <b>"{newsTitle}"</b>?
                  </p>
                </Grid>
              </Grid>
            </Typography>
            <Typography
              id="modal-modal-description"
              component={'span'}
              variant={'body2'}
            >
              <div
                className="btnContainer"
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <div className="attributeContainer1">
                  <button className="secondaryBtnBlue" onClick={this.props.hdlClose}>
                    Cancelar
                  </button>
                </div>
                <div className="attributeContainer1">
                  <button
                    className="mainBtn"
                    onClick={this.props.deleteNewsFunc}
                    disabled={false}
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </Typography>
          </Box>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapActionsToProps = {
  updateUser: UserActions.updateUser,
};

export default connect(mapStateToProps, mapActionsToProps)(ModalDeleteNews);
